/**
 * 流程动作枚举
 */
export enum FlowAction {
  /** 未知 */
  UNKNOWN = 'UNKNOWN',
  /** 提交审核 */
  SUBMIT_REVIEW = 'SUBMIT_REVIEW',
  /** 一审通过 */
  FIRST_REVIEW_PASS = 'FIRST_REVIEW_PASS',
  /** 一审驳回 */
  FIRST_REVIEW_REJECT = 'FIRST_REVIEW_REJECT',
  /** 二审通过 */
  SECOND_REVIEW_PASS = 'SECOND_REVIEW_PASS',
  /** 二审驳回 */
  SECOND_REVIEW_REJECT = 'SECOND_REVIEW_REJECT',
  /** 三审通过 */
  THIRD_REVIEW_PASS = 'THIRD_REVIEW_PASS',
  /** 三审驳回 */
  THIRD_REVIEW_REJECT = 'THIRD_REVIEW_REJECT',
  /** 签章通过 */
  SEAL_PASS = 'SEAL_PASS',
  /** 签章驳回 */
  SEAL_REJECT = 'SEAL_REJECT',
  /** 归档通过 */
  ARCHIVE_PASS = 'ARCHIVE_PASS',
  /** 归档驳回 */
  ARCHIVE_REJECT = 'ARCHIVE_REJECT',
  /** 打回重做 */
  FORCE_REDO = 'FORCE_REDO',
  /** 重新提交 */
  RESUBMIT = 'RESUBMIT',
  /** 作废 */
  CANCEL = 'CANCEL',
  /** 完成 */
  COMPLETE_PASS = 'COMPLETE_PASS'
}

/**
 * 报告流程动作（taskReportFlow processFlowWithComment / requestRedo 相关）
 */
export enum TaskReportFlowAction {
  FINALIZE_REPORT = 'FINALIZE_REPORT',
  REQUEST_REDO = 'REQUEST_REDO',
  REDO_APPROVE_PASS = 'REDO_APPROVE_PASS',
  REDO_APPROVE_REJECT = 'REDO_APPROVE_REJECT',
}


/**
 * 流程动作配置
 */
export const FLOW_ACTION_CONFIG = {
  [FlowAction.UNKNOWN]: {
    label: '未知',
    value: 'UNKNOWN'
  },
  [FlowAction.SUBMIT_REVIEW]: {
    label: '提交审核',
    value: 'SUBMIT_REVIEW'
  },
  [FlowAction.FIRST_REVIEW_PASS]: {
    label: '一审通过',
    value: 'FIRST_REVIEW_PASS'
  },
  [FlowAction.FIRST_REVIEW_REJECT]: {
    label: '一审驳回',
    value: 'FIRST_REVIEW_REJECT'
  },
  [FlowAction.SECOND_REVIEW_PASS]: {
    label: '二审通过',
    value: 'SECOND_REVIEW_PASS'
  },
  [FlowAction.SECOND_REVIEW_REJECT]: {
    label: '二审驳回',
    value: 'SECOND_REVIEW_REJECT'
  },
  [FlowAction.THIRD_REVIEW_PASS]: {
    label: '三审通过',
    value: 'THIRD_REVIEW_PASS'
  },
  [FlowAction.THIRD_REVIEW_REJECT]: {
    label: '三审驳回',
    value: 'THIRD_REVIEW_REJECT'
  },
  [FlowAction.SEAL_PASS]: {
    label: '签章通过',
    value: 'SEAL_PASS'
  },
  [FlowAction.SEAL_REJECT]: {
    label: '签章驳回',
    value: 'SEAL_REJECT'
  },
  [FlowAction.ARCHIVE_PASS]: {
    label: '归档通过',
    value: 'ARCHIVE_PASS'
  },
  [FlowAction.ARCHIVE_REJECT]: {
    label: '归档驳回',
    value: 'ARCHIVE_REJECT'
  },
  [FlowAction.FORCE_REDO]: {
    label: '打回重做',
    value: 'FORCE_REDO'
  },
  [FlowAction.RESUBMIT]: {
    label: '重新提交',
    value: 'RESUBMIT'
  },
  [FlowAction.CANCEL]: {
    label: '作废',
    value: 'CANCEL'
  },
  [FlowAction.COMPLETE_PASS]: {
    label: '完成',
    value: 'COMPLETE_PASS'
  }
};

/**
 * 根据审核结果获取对应的流程动作
 * 注意：这里的逻辑是根据当前状态来确定当前阶段应该执行的动作
 */
export function getFlowActionFromApprovalResult(
  isApproved: boolean,
  currentState: string
): FlowAction {
  if (isApproved) {
    // 根据当前状态确定当前阶段应该执行的动作
    if (currentState?.includes('一审') || currentState?.includes('首次')) {
      return FlowAction.FIRST_REVIEW_PASS;
    } else if (currentState?.includes('二审') || currentState?.includes('二次')) {
      return FlowAction.SECOND_REVIEW_PASS;
    } else if (currentState?.includes('三审') || currentState?.includes('三次')) {
      return FlowAction.THIRD_REVIEW_PASS;
    }
    return FlowAction.FIRST_REVIEW_PASS;
  } else {
    // 驳回动作
    if (currentState?.includes('一审') || currentState?.includes('首次')) {
      return FlowAction.FIRST_REVIEW_REJECT;
    } else if (currentState?.includes('二审') || currentState?.includes('二次')) {
      return FlowAction.SECOND_REVIEW_REJECT;
    } else if (currentState?.includes('三审') || currentState?.includes('三次')) {
      return FlowAction.THIRD_REVIEW_REJECT;
    }
    return FlowAction.FIRST_REVIEW_REJECT;
  }
}

import { TASK_REPORT_NODE_CONFIG, TaskReportNode } from './taskReportNode';

/**
 * 根据签章结果获取对应的流程动作
 */
export function getFlowActionFromSealResult(
  isApproved: boolean,
  currentState: string
): FlowAction {
  if (isApproved) {
    // 签章通过
    if (currentState?.includes('签章') || currentState?.includes('PENDING_SEAL')) {
      return FlowAction.SEAL_PASS;
    }
    return FlowAction.SEAL_PASS;
  } else {
    // 签章驳回
    return FlowAction.SEAL_REJECT;
  }
}

/**
 * 根据归档结果获取对应的流程动作
 */
export function getFlowActionFromArchiveResult(
  isApproved: boolean,
  currentState: string
): FlowAction {
  if (isApproved) {
    // 归档通过
    if (currentState?.includes('归档') || currentState?.includes('PENDING_ARCHIVE')) {
      return FlowAction.ARCHIVE_PASS;
    }
    return FlowAction.ARCHIVE_PASS;
  } else {
    // 归档驳回
    return FlowAction.ARCHIVE_REJECT;
  }
}

/**
 * 根据当前状态获取下一个节点ID
 */
export function getNextNodeId(currentState: string, isApproved: boolean): string {
  if (isApproved) {
    // 根据当前状态确定下一个节点
    if (currentState?.includes('一审') || currentState?.includes('首次')) {
      // 一审通过后，设置二审人员
      return 'SECOND_REVIEW';
    } else if (currentState?.includes('二审') || currentState?.includes('二次')) {
      // 二审通过后，设置三审人员
      return 'THIRD_REVIEW';
    } else if (currentState?.includes('三审') || currentState?.includes('三次')) {
      // 三审通过后，进入签章阶段
      return 'SEAL';
    } else if (currentState?.includes('签章') || currentState?.includes('PENDING_SEAL')) {
      // 签章通过后，进入归档阶段
      return 'ARCHIVE';
    } else if (currentState?.includes('归档') || currentState?.includes('PENDING_ARCHIVE')) {
      // 归档通过后，进入已归档状态
      return 'ARCHIVED';
    }
    return 'SECOND_REVIEW';
  } else {
    // 驳回后回到修改节点
    return 'MODIFY';
  }
}
